import { render } from "./CampaignsBulkBaseSelectorV2.vue?vue&type=template&id=436e4c22&scoped=true"
import script from "./CampaignsBulkBaseSelectorV2.vue?vue&type=script&lang=ts"
export * from "./CampaignsBulkBaseSelectorV2.vue?vue&type=script&lang=ts"

import "./CampaignsBulkBaseSelectorV2.vue?vue&type=style&index=0&id=436e4c22&scoped=true&lang=scss"
import "./CampaignsBulkBaseSelectorV2.vue?vue&type=style&index=1&id=436e4c22&lang=scss"
script.render = render
script.__scopeId = "data-v-436e4c22"

export default script